import { SET_OPENED_PROPERTY } from '../constants';

export const actionSetOpenedProperty = openedPropertyIndex => {
  return async dispatch => {
    dispatch({ type: SET_OPENED_PROPERTY, openedPropertyIndex });
  };
};

export default actionSetOpenedProperty;
